import React, { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePostRequest } from '../../service/PostTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import { endPoints } from '../../Config';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import SecuredFileChange from '../../components/SecuredFileChange';
import { InputTextarea } from 'primereact/inputtextarea';

const AddEditGateway = ({ editable, viewable, onHide, rowRecord, onCancel }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const testModeOptions = [
        { name: 'Active', id: true },
        { name: 'Inactive', id: false }
    ];

    const fraudCheckerOptions = [
        { name: 'Enable', id: true },
        { name: 'Disable', id: false }
    ];
    const acceptImageOptions = [
        { name: 'Yes', id: true },
        { name: 'No', id: false }
    ];
    const vendorOptions = [{ name: 'Blinq', id: 1 }];

    const gatewayLogoRef = useRef(null);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Name must contain only alphanumeric values'),

        rate: Yup.string()
            .matches(/^\d+$/, 'Rate should only contain numbers')
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),

        testMode: Yup.string().required('This field is required'),
        supportedCurrencies: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Currency must contain only alphanumeric values'),

        fraudCheckerEnabled: Yup.string().required('This field is required'),
        charge: Yup.string()
            .matches(/^\d+$/, 'Charge should only contain numbers')
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),
        customerStatus: Yup.string().required('This field is required'),
        globalStatus: Yup.string().required('This field is required'),
        acceptImage: Yup.string().required('This field is required'),
        vendorType: Yup.string().required('This field is required'),
        instruction: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Instructions must contain only alphanumeric values'),

        logo: Yup.string().required('This field is required')
    });
    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            id: '',
            name: '',
            logo: '',
            rate: '',
            testMode: '',
            supportedCurrencies: '',
            fraudCheckerEnabled: '',
            charge: '',
            customerStatus: '',
            globalStatus: '',
            acceptImage: '',
            vendorType: '',
            instruction: '',
            createdBy: 0
        },

        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('adminUser') || '{}');

            const formData = new FormData();
            if (!editable) {
                setLoadingBtn(true);

                formData.append('name', data?.name || '');
                formData.append('rate', data?.rate || '');
                formData.append('testMode', data?.testMode || '');
                formData.append('supportedCurrencies', data?.supportedCurrencies || '');
                formData.append('fraudCheckerEnabled', data?.fraudCheckerEnabled || '');
                formData.append('charge', data?.charge || '');
                formData.append('customerStatus', data?.customerStatus || '');
                formData.append('globalStatus', data?.globalStatus || '');
                formData.append('acceptImage', data?.acceptImage || '');
                formData.append('vendorType', data?.vendorType || '');
                formData.append('instruction', data?.instruction || '');
                formData.append('createdBy', user?.data?.userId || '');

                if (selectedFile) formData.append('Logo', selectedFile);

                const response = await dispatch(handlePostRequest(formData, endPoints.addPaymentGateway, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            } else {
                setLoadingBtn(true);

                formData.append('id', data?.id || '');
                formData.append('name', data?.name || '');
                formData.append('rate', data?.rate || '');
                formData.append('testMode', data?.testMode || '');
                formData.append('supportedCurrencies', data?.supportedCurrencies || '');
                formData.append('fraudCheckerEnabled', data?.fraudCheckerEnabled || '');
                formData.append('charge', data?.charge || '');
                formData.append('customerStatus', data?.customerStatus || '');
                formData.append('globalStatus', data?.globalStatus || '');
                formData.append('acceptImage', data?.acceptImage || '');
                formData.append('vendorType', data?.vendorType || '');
                formData.append('instruction', data?.instruction || '');
                formData.append('modifiedBy', user?.data?.userId || '');

                if (selectedFile) formData.append('Logo', selectedFile);

                const response = await dispatch(handlePutRequest(formData, endPoints.updatePaymentGateway, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            }
        }
    });

    const getGatewaybyId = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getPaymentGatewayById(rowRecord.id), true);
        if (response) {
            // const dateformat = response?.dateOfBirth ? formatedDate(response?.dateOfBirth) : '';
            // formik.setFieldValue('dateOfBirth', dateformat);
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('name', response?.data?.name);
            formik.setFieldValue('rate', response?.data?.rate);
            formik.setFieldValue('testMode', response?.data?.testMode);
            formik.setFieldValue('supportedCurrencies', response?.data?.supportedCurrencies);
            formik.setFieldValue('fraudCheckerEnabled', response?.data?.fraudCheckerEnabled);
            formik.setFieldValue('charge', response?.data?.charge);
            formik.setFieldValue('customerStatus', response?.data?.customerStatus);
            formik.setFieldValue('globalStatus', response?.data?.globalStatus);
            formik.setFieldValue('acceptImage', response?.data?.acceptImage);
            formik.setFieldValue('vendorType', response?.data?.vendorType);
            formik.setFieldValue('instruction', response?.data?.instruction);
            formik.setFieldValue('logo', response?.data?.logoPath);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        if (editable || viewable) {
            getGatewaybyId();
        }
    }, [rowRecord]);

    const handleGatewayIcon = () => {
        gatewayLogoRef.current.click();
    };

    function handleGatewayImageChange(event) {
        setSelectedFile(null);
        formik.setFieldValue('logo', '');
        const selectedFile = event.target.files[0];
        const fileTypes = ['image'];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
        } else if (newFile) {
            formik.setFieldValue('logo', newFile?.name);

            setSelectedFile(newFile);
        }
    }
    function formatedDate(originalDate) {
        const createDate = new Date(originalDate);

        const year = createDate.getFullYear();
        const month = (createDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
        const day = createDate.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="name">
                            Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="name" name="name" placeholder="Enter Gateway Name" value={formik?.values?.name} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>{' '}
                <div className="col-12 md:col-6">
                    <div className="mb-3">
                        <div className="field">
                            <label htmlFor="logo">
                                Logo <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="file-input-container file-input-wrapper w-100" onClick={handleGatewayIcon}>
                                <input type="file" accept="image/*" style={{ display: 'none' }} ref={gatewayLogoRef} onChange={handleGatewayImageChange} className="file-input-field" disabled={viewable} />
                                <input type="text" placeholder="Choose a file..." value={formik?.values?.logo} readOnly className="file-input-field" />
                            </div>
                            {formik.touched.logo && formik.errors.logo ? <small className="p-error">{formik.errors.logo}</small> : ''}
                        </div>
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="rate">
                            Rate <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="rate" name="rate" placeholder="Enter Rate" value={formik?.values?.rate} maxLength={8} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.rate && formik.errors.rate && <small className="p-error">{formik.errors.rate}</small>}
                    </div>
                </div>{' '}
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="testMode">
                            Test Mode <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            id="testMode"
                            name="testMode"
                            value={formik?.values?.testMode}
                            options={testModeOptions}
                            optionLabel="name"
                            optionValue="id"
                            onChange={formik.handleChange}
                            placeholder="Select Test Mode"
                            className="w-full"
                            disabled={viewable}
                        />
                        {formik.touched.testMode && formik.errors.testMode && <small className="p-error">{formik.errors.testMode}</small>}
                    </div>
                </div>{' '}
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="supportedCurrencies">
                            Currency Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="supportedCurrencies" name="supportedCurrencies" placeholder="Enter Currency Name" value={formik?.values?.supportedCurrencies} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.supportedCurrencies && formik.errors.supportedCurrencies && <small className="p-error">{formik.errors.supportedCurrencies}</small>}
                    </div>
                </div>{' '}
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="fraudCheckerEnabled">
                            Fraud Checker <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            id="fraudCheckerEnabled"
                            name="fraudCheckerEnabled"
                            value={formik?.values?.fraudCheckerEnabled}
                            options={fraudCheckerOptions}
                            optionLabel="name"
                            optionValue="id"
                            onChange={formik.handleChange}
                            placeholder="Select"
                            className="w-full"
                            disabled={viewable}
                        />
                        {formik.touched.fraudCheckerEnabled && formik.errors.fraudCheckerEnabled && <small className="p-error">{formik.errors.fraudCheckerEnabled}</small>}
                    </div>
                </div>{' '}
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="charge">
                            Charge <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="charge" name="charge" placeholder="Enter Charge" value={formik?.values?.charge} maxLength={13} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.charge && formik.errors.charge && <small className="p-error">{formik.errors.charge}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="customerStatus">
                            Customer Status <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            id="customerStatus"
                            name="customerStatus"
                            value={formik?.values?.customerStatus}
                            options={testModeOptions}
                            optionLabel="name"
                            optionValue="id"
                            onChange={formik.handleChange}
                            placeholder="Select"
                            className="w-full"
                            disabled={viewable}
                        />
                        {formik.touched.customerStatus && formik.errors.customerStatus && <small className="p-error">{formik.errors.customerStatus}</small>}
                    </div>
                </div>{' '}
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="globalStatus">
                            Global Status <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            id="globalStatus"
                            name="globalStatus"
                            value={formik?.values?.globalStatus}
                            options={testModeOptions}
                            optionLabel="name"
                            optionValue="id"
                            onChange={formik.handleChange}
                            placeholder="Select"
                            className="w-full"
                            disabled={viewable}
                        />
                        {formik.touched.globalStatus && formik.errors.globalStatus && <small className="p-error">{formik.errors.globalStatus}</small>}
                    </div>
                </div>{' '}
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="acceptImage">
                            Accept Image <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            id="acceptImage"
                            name="acceptImage"
                            value={formik?.values?.acceptImage}
                            options={acceptImageOptions}
                            optionLabel="name"
                            optionValue="id"
                            onChange={formik.handleChange}
                            placeholder="Select"
                            className="w-full"
                            disabled={viewable}
                        />
                        {formik.touched.acceptImage && formik.errors.acceptImage && <small className="p-error">{formik.errors.acceptImage}</small>}
                    </div>
                </div>{' '}
                <div className="col-12 md:col-12">
                    <div className="field mb-3">
                        <label htmlFor="vendorType">
                            Vendor Type <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            id="vendorType"
                            name="vendorType"
                            value={formik?.values?.vendorType}
                            options={vendorOptions}
                            optionLabel="name"
                            optionValue="id"
                            onChange={formik.handleChange}
                            placeholder="Select"
                            className="w-full"
                            disabled={viewable}
                        />
                        {formik.touched.vendorType && formik.errors.vendorType && <small className="p-error">{formik.errors.vendorType}</small>}
                    </div>
                </div>{' '}
                <div className="col-12 md:col-12">
                    <div className="field mb-3">
                        <label htmlFor="instruction">
                            Instruction <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputTextarea id="instruction" name="instruction" value={formik?.values?.instruction || ''} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.instruction && formik.errors.instruction && <small className="p-error">{formik.errors.instruction}</small>}
                    </div>
                </div>
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                {!viewable && (
                    <Button label={editable ? 'Update' : 'Save'} icon={editable ? 'pi pi-pencil' : 'pi pi-save'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                )}
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onCancel()} />
            </div>
        </form>
    );
};

export default AddEditGateway;
